
import { Component, Vue } from "vue-property-decorator";
import MenuButton from "./MenuButton.vue";

const of = 32;
@Component({
  components: {
    MenuButton,
  },
})
export default class MenuEquipo extends Vue {

  calcOffset(idx: number): string {
    return `${of * idx}px`;
  }

}
